import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "w-full h-full flex items-center justify-center !bg-gradient-to-b from-primary100 to-primary700 rounded-full" }
const _hoisted_3 = { class: "text-lg text-white" }

import { ref } from 'vue';
interface Props {
    imgUrl: any,
    imgAlt: string,
    styleBox?: String
    LoadImg?: any
    lastName?: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAvatar',
  props: {
    imgUrl: null,
    imgAlt: null,
    styleBox: null,
    LoadImg: null,
    lastName: null
  },
  emits: ["load"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'load'): void

}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    imgUrl: any,
    imgAlt: string,
    styleBox?: String
    LoadImg?: any
    lastName?: any
};


const imgLoad = ref<boolean>(false)

const styleBoxAvatar = ref<String>('')
if (props.styleBox) {
    styleBoxAvatar.value = props.styleBox
} else {
    styleBoxAvatar.value = 'box-avatar'
}

function handelLoad() {
    emit('load')
    imgLoad.value = true
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(styleBoxAvatar.value)
  }, [
    _withDirectives(_createElementVNode("img", {
      src: __props.imgUrl,
      class: "w-full h-full object-cover rounded-full",
      alt: __props.imgAlt,
      onLoad: handelLoad
    }, null, 40, _hoisted_1), [
      [_vShow, imgLoad.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.lastName[0]), 1)
    ], 512), [
      [_vShow, !imgLoad.value]
    ])
  ], 2))
}
}

})